import { render } from "./Secondary1.vue?vue&type=template&id=e310e5d4&ts=true"
import script from "./Secondary1.vue?vue&type=script&lang=ts"
export * from "./Secondary1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/Secondary1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e310e5d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e310e5d4', __exports__)) {
    api.reload('e310e5d4', __exports__)
  }
  
  module.hot.accept("./Secondary1.vue?vue&type=template&id=e310e5d4&ts=true", () => {
    api.rerender('e310e5d4', render)
  })

}


export default __exports__